import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'loyalty';

  constructor(iconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    this.addSvgIcons(iconRegistry, domSanitizer, [
      'list-icon', 'map-icon'
    ]);
  }

  private addSvgIcons(iconRegistry: MatIconRegistry, domSanitizer: DomSanitizer, iconNames: string[]) {
    for (const iconName of iconNames) {
      iconRegistry.addSvgIcon(iconName, domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${iconName}.svg`));
    }
  }
}
